import { render, staticRenderFns } from "./dispatchTable.vue?vue&type=template&id=95336c64&scoped=true&"
import script from "./dispatchTable.vue?vue&type=script&lang=js&"
export * from "./dispatchTable.vue?vue&type=script&lang=js&"
import style0 from "./dispatchTable.vue?vue&type=style&index=0&id=95336c64&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95336c64",
  null
  
)

export default component.exports